import styled from '@emotion/styled';
import React, { FC, Fragment } from 'react';

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  /* Show the tooltip text when you mouse over the tooltip container */
  &:hover > div {
    visibility: visible;
  }
`;

const TooltipContent = styled.div`
  visibility: hidden;
  width: 176px;
  text-align: center;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  background-color: #4694ce;
  color: #ffffff;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 10px);
  &:before {
    content: '';
    width: 12px;
    height: 12px;
    left: 50%;
    z-index: 0;
    transform: translate(-50%, -50%) rotate(45deg);
    position: absolute;
    pointer-events: none;
    display: flex;
    background: #4694ce;
    top: 0;
  }
`;

export interface PopoverTooltipProps {
  text?: string;
}

const Tooltip: FC<PopoverTooltipProps> = props => {
  if (props.text) {
    return (
      <TooltipWrapper>
        {props.children}
        <TooltipContent>{props.text}</TooltipContent>
      </TooltipWrapper>
    );
  }
  return <Fragment>{props.children}</Fragment>;
};

export { Tooltip };
